import TabsController from './tabs_controller';
import { saveState, restoreState } from '../location_hash';

function tabName(el) {
  return `#${el.dataset.tabName}`;
}

export default class extends TabsController {
  static targets = ['tab', 'panel', 'title', 'nextButton', 'backButton', 'saveButton']

  initialize() {
    if (!window.location.hash) restoreState();
    this.activeTabClasses = (this.data.get('activeTab') || 'active').split(' ');
    this.index = this.relevantTabIndex();
  }

  relevantTabIndex() {
    return this.errorPanelIndexes()
      .concat(this.activeIndexTabIndexes())
      .find(Number.isInteger) || 0;
  }

  activeIndexTabIndexes() {
    return this.tabTargets.map((el, index) => {
      if (window.location.hash === tabName(el)) return index;
      return undefined;
    });
  }

  errorPanelIndexes() {
    return this.panelTargets.map((el, index) => {
      if (el.querySelector('.is-invalid')) return index;
      return undefined;
    });
  }

  next(event) {
    event.preventDefault();
    if (this.index === this.tabTargets.length - 1) return;

    this.index += 1;
  }

  back(event) {
    event.preventDefault();
    if (this.index === 0) return;

    this.index -= 1;
  }

  change(event) {
    event.preventDefault();
    if (!this.isParentFormChanged()) {
      this.index = this.tabTargets.indexOf(event.currentTarget);
    }
  }

  showTab() {
    this.tabTargets.forEach((tab, index) => {
      const panel = this.panelTargets[index];
      panel.classList.toggle('hidden', index !== this.index);

      if (index === this.index) {
        tab.classList.add(...this.activeTabClasses);
        saveState(tabName(tab));
      } else {
        tab.classList.remove(...this.activeTabClasses);
      }
    });
  }

  get index() {
    return parseInt(this.data.get('index') || 0, 10);
  }

  set index(value) {
    this.data.set('index', value);
    this.showTab();
    this.updateButtons();
  }

  updateButtons() {
    this.hideBackButton();
    this.showBackButton();
    this.hideNextButton();
    this.showNextButton();
    this.showSaveButton();
    this.hideSaveButton();
  }

  hideBackButton() {
    if (this.index !== 0) return;

    this.backButtonTarget.classList.add('disabled');
  }

  showBackButton() {
    if (this.index <= 0) return;

    this.backButtonTarget.classList.remove('disabled');
  }

  hideNextButton() {
    if (this.index !== this.tabTargets.length - 1) return;

    this.nextButtonTarget.classList.add('hidden');
  }

  showNextButton() {
    if (this.index >= this.tabTargets.length - 1) return;

    this.nextButtonTarget.classList.remove('hidden');
  }

  showSaveButton() {
    if (this.index < this.tabTargets.length - 1) return;

    this.saveButtonTarget.classList.remove('hidden');
  }

  hideSaveButton() {
    if (this.index == this.tabTargets.length - 1) return;

    this.saveButtonTarget.classList.add('hidden');
  }

  isParentFormChanged() {
    const formController = this.application.getControllerForElementAndIdentifier(this.element.parentElement, "unsaved-changes");
    if (formController) {
      return formController.data.get("changed") === "true"
    }
    return false;
  }
}
